import { Button, message, Modal, Switch, Typography } from 'antd'
import styled from 'styled-components'
import { IconFont, BasTitle, UpLoadFile } from '@/components'
import { useState } from 'react'
import { Message } from '@/components/message'
import { downloadTemplate, downloadFailedFile } from '@/api/waf-create-task'
import { importSuccessFile } from '@/api/waf-site'
import { RcFile } from 'antd/es/upload'
import { t } from '@/i18n'

export const BatchAddModal = props => {
  const { closeModal, visible } = props
  // const [updata, setUpdata] = useState<any>(id)
  const [err, setErr] = useState(false)
  let userData
  try {
    userData = JSON.parse(localStorage.getItem('token'))
  } catch (error) {}
  const [uploadCsvLoading, setUploadCsvLoading] = useState(false)
  const [uploadSuccess, setUploadSuccess] = useState(false)
  const [uploaded, setUploaded] = useState(false)
  const [dataList, setDataList] = useState({})
  const [fileName, setFileName] = useState('')
  const [switchVal, setSwitchVal] = useState(true)
  const [file, setFile] = useState<RcFile>()

  const tableToExcel = () => {
    downloadFailedFile({ file_path: dataList.failedRecord }).catch(err => {
      const uri = `data:text/csv;charset=utf-8,\ufeff${encodeURIComponent(err)}`
      // 通过创建a标签实现
      const link = document.createElement('a')
      link.href = uri
      // 对下载的文件命名
      link.download = t('错误数据.csv')
      link.click()
    })
  }
  const importSuccessData = () => {
    setUploadCsvLoading(true)
    const formData = new FormData()
    formData.append('file', file as RcFile)
    formData.append('no_rewrite', !switchVal)
    fetch(
      `${
        process.env.NODE_ENV === 'dev' ? '/api' : ''
      }/portal/verify/waf/resource/site/batchFileAnalysis`,

      {
        method: 'POST',
        body: formData,
        headers: {
          'user-id': userData.id,
          token: userData.token,
        },
      },
    )
      .then(res => res.json())
      .then(res => {
        if (res.code === 200) {
          setUploadSuccess(true)
          setFile(null)
          setDataList(res.data)
        } else {
          setFile(null)
          setErr(true)
          Message.error(res.msg)
        }
      })
      .finally(() => {
        setUploadCsvLoading(false)
      })
  }
  return (
    <Container
      visible={visible}
      width={600}
      centered
      title={<BasTitle title={t('批量导入')} />}
      maskClosable={false}
      footer={
        <>
          {uploadSuccess ? (
            <Button
              type="primary"
              onClick={() => {
                closeModal(true)
              }}
            >
              {t('确定')}
            </Button>
          ) : (
            <>
              <Button
                // type="primary"
                onClick={() => {
                  closeModal(false)
                }}
              >
                {t('取消')}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  importSuccessData()
                }}
                loading={uploadCsvLoading}
                disabled={!file?.name}
              >
                {t('确定')}
              </Button>
            </>
          )}
        </>
      }
      onCancel={closeModal}
      afterClose={() => {
        setUploadSuccess(false)
        setDataList({})
        setErr(false)
        setUploadCsvLoading(false)
        setSwitchVal(true)
        setUploaded(false)
        setFileName('')
        setFile(null)
      }}
    >
      {uploadSuccess ? (
        <div>
          <ResultContainer>
            <IconFont type={'icon-chenggong2'} className="icon" />
            <div className="result" style={{ margin: '40px 0' }}>
              {t('导入成功')}
            </div>
            <div className="content-container">
              <div className="content">
                <div>{t('变更数据')}</div>
                <div>
                  <span className="num">{dataList?.success || 0}</span>
                  {t('条')}
                </div>
              </div>
              <div className="content">
                <div>{t('错误数据')}</div>
                <div>
                  <span className="num-err">{dataList?.failed || 0}</span>
                  {t('条')}
                </div>
                <Button
                  disabled={!(dataList.failed > 0)}
                  onClick={() => {
                    tableToExcel()
                  }}
                >
                  {t('下载')}
                </Button>
              </div>
              <div className="content">
                <div>{t('重复数据')}</div>
                <div>
                  <span className="num">{dataList?.repeated || 0}</span>
                  {t('条')}
                </div>
              </div>
            </div>
          </ResultContainer>
        </div>
      ) : (
        <>
          <div>
            {t('将变更的数据覆盖：')}
            <Switch checked={switchVal} onChange={setSwitchVal} />
          </div>
          <div style={{ width: 536, height: 196, marginTop: 27 }}>
            <UpLoadFile
              showUploadList={false}
              customRequest={() => {}}
              // status={err && 'error'}
              className={err && 'err'}
              // headers={{
              //   'user-id': userData.id,
              //   token: userData.token,
              // }}
              // action={`${
              //   process.env.NODE_ENV === 'production' ? '' : '/api'
              // }/portal/verify/waf/resource/site/batchFileAnalysis`}
              beforeUpload={file => {
                const reg = /\.csv$/
                if (reg.test(file?.name)) {
                  setFile(file as RcFile)
                  // setFileStatus(true)
                  setUploaded(true)
                  return true
                }
                setErr(true)
                Message.error(t('仅支持上传.csv文件 '))
                return false
              }}
              // onChange={({ file }) => {
              //   if (file.status === 'uploading') {
              //     setUploadCsvLoading(true)
              //     return
              //   }
              //   if (
              //     file.status === 'done' ||
              //     file.status === 'error' ||
              //     file.status === 'success'
              //   ) {
              //     setUploadCsvLoading(false)
              //   }
              //   if (file.status === 'done') {
              //     const { code, msg } = file.response
              //     // console.log(file.name)
              //     if (code === 200) {
              //       setErr(false)
              //       setDataList(file.response.data)
              //       setFileName(file.name)
              //       setUploaded(true)
              //       // setUploadSuccess(true)
              //       // getEmailList$.emit()
              //       // setSteps(2)
              //     } else {
              //       setErr(true)
              //       Message.error(msg || '上传失败')
              //     }
              //     return
              //   }
              //   if (file.status === 'error') {
              //     setErr(true)
              //     Message.error('上传失败')
              //   }
              // }}
              // data={{
              //   no_rewrite: switchVal,
              // }}
              name={'file'}
              maxCount={1}
              text={
                file?.name ? (
                  <div style={{ color: '#666', height: 45 }}>
                    <div>{file?.name}</div>
                  </div>
                ) : (
                  <div style={{ color: '#666' }}>
                    <span style={{ color: err ? '#f5222d' : '#666' }}>
                      {t('将文件拖拽到此处，或')}
                    </span>
                    <Typography.Link style={{ color: '#4238c9' }}>
                      <u>{t('点击上传')}</u>
                    </Typography.Link>
                    <div style={{ marginTop: 12 }}>
                      {t('支持上传CSV格式（UTF-8），文件不超过10M')}
                    </div>
                  </div>
                )
              }
            />
          </div>
          <DownloadCSV>
            <a
              rel="noopener noreferrer"
              target="_blank"
              onClick={() => {
                downloadTemplate().catch(err => {
                  const uri = `data:text/csv;charset=utf-8,\ufeff${encodeURIComponent(err)}`
                  // 通过创建a标签实现
                  const link = document.createElement('a')
                  link.href = uri
                  // 对下载的文件命名
                  link.download = t('站点批量导入模板.csv')
                  link.click()
                })
              }}
            >
              <IconFont style={{ color: '#031A79' }} type="icon-xiangmuwenjianmobanku_mobanku" />
              {t('下载CSV模板')}
            </a>
          </DownloadCSV>
        </>
      )}
    </Container>
  )
}

const Container = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
    }
  }
  .err {
    border: 1px dashed #f5222d;
  }
`
const DownloadCSV = styled.div`
  margin-top: 20px;
`

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .icon {
    font-size: 54px;
  }
  .result {
    margin: 5px 0;
    margin-top: 10px;
    font-size: 24px;
    //font-family: 500;
  }
  .text {
    color: #666;
    line-height: 1.2;
  }
  .content-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .content {
    width: 168px;
    height: 152px;
    background: #f7f8f9;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      margin-bottom: 12px;
    }
  }
  .num {
    font-weight: bold;
    font-size: 18px;
    color: #558492;
  }
  .num-err {
    font-weight: bold;
    font-size: 18px;
    color: #f53f3f;
  }
`
